import reducer from './reducer';

export {
  setPosition,
  setStopDragging,
  setTrackDimensions,
  setValue,
} from './actions';

export default reducer;
